// extracted by mini-css-extract-plugin
export default {"wrap":"consultations_wrap__q4bD1"};